import { toast } from '@/helpers/toast/toast.helper'
import { call, put } from 'redux-saga/effects'
import { selectDepartmentAction } from '../../handles'
import { delay, getCurrentTimeInMinutes, getTodaySchedule, timeToMinutes } from './helpers'
import { ScheduleByDepartmentModel } from '@/models/schedule'
import { t } from 'i18next'
import { fetchSchedule } from '../_http/schedule'

export function* setDepartmentSaga(action: ReturnType<typeof selectDepartmentAction.request>) {
  try {
    const { selectedDepartment, userAuthenticated } = action.payload
    if (userAuthenticated?.role === 'MASTER')
      return yield put(selectDepartmentAction.success({ departmentCheck: true, selectedDepartment }))

    const scheduleByDepartment: ScheduleByDepartmentModel = yield fetchSchedule({
      departmentId: selectedDepartment?.id,
      companyId: selectedDepartment?.companyId
    })

    if (!scheduleByDepartment?.id || !!scheduleByDepartment?.isLoginBeforeHour)
      return yield put(selectDepartmentAction.success({ departmentCheck: true, selectedDepartment }))

    const todaySchedule = getTodaySchedule(scheduleByDepartment.schedule)

    if (!todaySchedule) throw new Error('schedule_not_found')

    const currentTimeInMinutes = getCurrentTimeInMinutes()
    const startTimeInMinutes = timeToMinutes(todaySchedule.startTime)
    if (startTimeInMinutes > currentTimeInMinutes) throw new Error('login_before_hour')
    yield toast({
      type: 'success',
      message: `${t('translation:setDepartmentSaga.department')} ${selectedDepartment?.name}`
    })
    yield put(selectDepartmentAction.success({ departmentCheck: true, selectedDepartment }))
  } catch (error) {
    if (error.message === 'schedule_not_found') {
      yield toast({
        type: 'error',
        message: `${t('translation:setDepartmentSaga.scheduleNotFoundPart1')} ${
          action.payload.selectedDepartment?.name
        } ${t('translation:setDepartmentSaga.scheduleNotFoundPart2')}`
      })
      yield put(
        selectDepartmentAction.failure({
          isError: true,
          departmentCheck: null,
          selectedDepartment: action.payload?.returnOldDepartment ? null : action.payload?.selectedDepartment
        })
      )
      return
    }

    if (error.message === 'login_before_hour') {
      yield toast({
        type: 'error',
        message: `${t('translation:setDepartmentSaga.scheduleNotFoundPart1')} ${
          action.payload.selectedDepartment?.name
        } ${t('translation:setDepartmentSaga.loginBeforeHour')}`
      })
      yield call(delay, 500)
      yield put(
        selectDepartmentAction.failure({
          isError: true,
          departmentCheck: null,
          selectedDepartment: action.payload?.returnOldDepartment ? null : action.payload?.selectedDepartment
        })
      )
      return
    }

    yield toast({
      type: 'error',
      message: t('translation:setDepartmentSaga.internalError')
    })
    yield put(
      selectDepartmentAction.failure({
        isError: true,
        departmentCheck: null,
        selectedDepartment: action.payload?.returnOldDepartment ? null : action.payload?.selectedDepartment
      })
    )
  }
}
